import { render } from "./MenuNode.vue?vue&type=template&id=11cb2cbe&scoped=true"
import script from "./MenuNode.vue?vue&type=script&lang=js"
export * from "./MenuNode.vue?vue&type=script&lang=js"

import "./MenuNode.vue?vue&type=style&index=0&id=11cb2cbe&scoped=true&lang=css"

import exportComponent from "/home/runner/work/system-jj-frontend/system-jj-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11cb2cbe"]])

export default __exports__